import { combineReducers } from "redux";

import business from "./reducers/business";
import personal from "./reducers/personal";

const trustPassReducers = combineReducers({
  business: business,
  personal: personal,
});

export default trustPassReducers;



// WEBPACK FOOTER //
// ./src/features/trustpass/reducers.js